import { Component, Input, OnInit } from '@angular/core';
import { BookingController } from '@shared/src/controllers/booking/booking.controller';
import { iBooking } from '@shared/src/dtos/booking/iBooking';
import { SharedBookingCardComponent } from '../bookingcard/shared.booking.card.component';
import { HColor, HString } from '@shared/src/public-api';

@Component({
  selector: 'shared-booking-strip',
  templateUrl: './shared.booking.strip.component.html',
  styleUrls: ['./shared.booking.strip.component.scss']
})
export class SharedBookingStripComponent implements OnInit {


  public departureAddressSkin: string;
  public arrivalAddressSkin: string;
  public departureAddressSkinColor: string;
  public departureAddressSkinBackgroundColor: string;
  public arrivalAddressSkinColor: string;
  public arrivalAddressSkinBackgroundColor: string;
  public carrierCodeSkin: string;
  public carrierCodeColor: string;
  public carrierCodeBackgroundColor: string;
  public maritimeAgencySkin: string;
  public maritimeAgencyColor: string;
  public maritimeAgencyBackgroundColor: string;

  public slotsStatus: string;


  constructor(protected bookingController: BookingController) { }

  ngOnInit(): void { }

  private _booking: iBooking;
  @Input() public set booking(v: iBooking) {
    if (this._booking == v)
      return;
    this._booking = v;
    this.calculateGeneralClass();
    this.calculateSlotStatus();
  }

  public get booking(): iBooking {
    return this._booking;
  }

  public generalClass = "";
  public calculateGeneralClass() {
    this.generalClass = SharedBookingCardComponent.getGeneralClass(this.booking);


    if (this.booking) {
      this.departureAddressSkin = this.getCodeOr(this.booking.departureAddressSkin);
      if (this.departureAddressSkin === "---") {
        this.departureAddressSkinBackgroundColor = "var(--noAddressBackgroundColor)";
        this.departureAddressSkinColor = "var(--noAddressColor)";
      } else {
        this.departureAddressSkinBackgroundColor = HColor.getColorFromString(this.booking.departureAddressSkin);
        this.departureAddressSkinColor = HColor.getWhiteBlackFromColor(this.departureAddressSkinBackgroundColor);
      }
      this.arrivalAddressSkin = this.getCodeOr(this.booking.arrivalAddressSkin);
      if (this.departureAddressSkin === "---") {
        this.arrivalAddressSkinBackgroundColor = "var(--noAddressBackgroundColor)";
        this.arrivalAddressSkinColor = "var(--noAddressColor)";
      } else {
        this.arrivalAddressSkinBackgroundColor = HColor.getColorFromString(HString.slice(0, 2, this.booking.arrivalAddressSkin));
        this.arrivalAddressSkinColor = HColor.getWhiteBlackFromColor(this.arrivalAddressSkinBackgroundColor);
      }

      this.carrierCodeSkin = this.getCodeOr(this.booking.carrierCode);
      if (this.carrierCodeSkin === "---") {
        this.carrierCodeBackgroundColor = "var(--noAddressBackgroundColor)";
        this.carrierCodeColor = "var(--noAddressColor)";
      } else {
        this.carrierCodeBackgroundColor = HColor.getColorFromString(this.carrierCodeSkin);
        this.carrierCodeColor = HColor.getWhiteBlackFromColor(this.carrierCodeBackgroundColor);
      }

      this.maritimeAgencySkin = this.getCodeOr(this.booking.maritimeAgency);
      if (this.departureAddressSkin === "---") {
        this.maritimeAgencyBackgroundColor = "var(--noAddressBackgroundColor)";
        this.maritimeAgencyColor = "var(--noAddressColor)";
      } else {
        this.maritimeAgencyBackgroundColor = HColor.getColorFromString(this.maritimeAgencySkin);
        this.maritimeAgencyColor = HColor.getWhiteBlackFromColor(this.maritimeAgencyBackgroundColor);
      }
    }
  }


  public calculateSlotStatus() {
    let result: string = undefined;
    if (!this._booking) {
      return;
    } else {
      let total = this._booking.places;
      let available = this._booking.slotsAvailable;
      let percentage = (available * 100 / total);

      if (percentage == 0) {
        result = "completed";
      } else if (percentage <= 50 && percentage > 0) {
        result = "partially-occupied";
      } else if (percentage > 50) {
        result = "incompleted"
      }
    }
    this.slotsStatus = result;
  }

  public getCodeOr(value: string): string {
    if (value == null || value == "")
      return "---";
    return value;
  }

  pretty(value: any): string {
    return JSON.stringify(value);
  }

}
